import { Link } from 'gatsby';
import { EuiButton } from '@elastic/eui';
import NavButtons from 'components/Quick_Installation/NavButtons';
import ForumBox from 'components/Quick_Installation/ONVIF/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiButton,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};